import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';
import { fetchLinkStatus, isKitchenTenant, switchSession } from '../api/academyLink';

// A Kitchen session reached by the handoff shows "Volver a mi tenant": the same
// handoff in reverse, valid only for the linked pair (the server decides). A
// Kitchen with its own password login has no link, so no bar.
const KitchenReturnBar: React.FC = () => {
  const { t } = useTranslation('academyLink');
  const tenantId = useAuthStore((s) => s.user?.tenant_id);
  const [linked, setLinked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isKitchenTenant(tenantId)) { setLinked(false); return; }
    let live = true;
    fetchLinkStatus()
      .then((s) => { if (live) setLinked(s.linked && s.side === 'kitchen'); })
      .catch(() => undefined);
    return () => { live = false; };
  }, [tenantId]);

  if (!linked) return null;
  const back = async () => {
    setBusy(true); setError('');
    try {
      await switchSession();
      window.location.assign('/');
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      setBusy(false);
    }
  };
  return (
    <div data-academy="kitchen-return-bar" style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, padding: '6px 16px',
      fontSize: 12, borderBottom: '1px solid var(--color-border)',
      backgroundColor: 'var(--color-surface, var(--color-base))', color: 'var(--color-text-subtle)',
    }}>
      <span>{t('bar.label')}</span>
      <button type="button" onClick={back} disabled={busy} style={{
        height: 26, padding: '0 12px', borderRadius: 4, border: 'none', cursor: 'pointer',
        backgroundColor: 'var(--color-brand)', color: 'var(--color-on-brand)', fontSize: 12, fontWeight: 600,
      }}>
        {busy ? t('bar.backing') : t('bar.back')}
      </button>
      {error && <span role="alert" style={{ color: 'var(--color-error, var(--en-error))' }}>{t('bar.error', { detail: error })}</span>}
    </div>
  );
};

export default KitchenReturnBar;
